import { useMemo } from 'react'

import {
  parseCallbackParams,
  type IOAuthCallbackResult,
} from 'src/app/auth/adapters/oauth-redirect/parse-callback-params'
import {
  consumePostLoginRedirect,
  setPostLoginRedirect,
} from 'src/app/auth/adapters/oauth-redirect/post-login-redirect-store'
import { redirectToProvider } from 'src/app/auth/adapters/oauth-redirect/redirect-to-provider'
import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'

export interface IRedirectToProviderParams {
  provider: OAuthProvider
  postLoginRedirect?: string
}

export interface IUseOAuthRedirectReturn {
  redirectTo: (params: IRedirectToProviderParams) => void
  parseCallback: (search: string) => IOAuthCallbackResult
  consumePostLoginRedirect: () => string | undefined
}

export const useOAuthRedirect = (): IUseOAuthRedirectReturn => {
  return useMemo(
    () => ({
      redirectTo: (params: IRedirectToProviderParams) => {
        if (params.postLoginRedirect) {
          setPostLoginRedirect(params.postLoginRedirect)
        }
        redirectToProvider(params.provider)
      },
      parseCallback: (search: string) => parseCallbackParams(search),
      consumePostLoginRedirect: () => consumePostLoginRedirect(),
    }),
    [],
  )
}
